// Module
var code = "<button type=\"button\" class=\"product-action btn btn--large btn--primary btn--icon btn--icon-right icon-basket\" ng-click=\"execute()\"> <span class=\"product-action--preorder\" system-dictionary=\"Preorder\"> </span> </button>";
// Exports
module.exports = code;